import { createSlice } from "@reduxjs/toolkit";
const initialState = localStorage.getItem("achPayment")
  ? JSON.parse(localStorage.getItem("achPayment"))
  : {
      achPayment: {},
      sameDayPayment: {},
      routingDetails: {},
    };
export const achPaymentSlice = createSlice({
  name: "achPayment",
  initialState,
  reducers: {
    setAchPayment: (state, action) => {
      state.achPayment = action.payload;
      localStorage.setItem("achPayment", JSON.stringify(state));
    },
    setSameDayPayment: (state, action) => {
      state.sameDayPayment = action.payload;
      localStorage.setItem("achPayment", JSON.stringify(state));
    },
    resetAchPayment: (state) => {
      return {
        achPayment: {},
        sameDayPayment: {},
        routingDetails: {},
      };
    },
    handleRoutingDetails: (state, action) => {
      state.routingDetails = action.payload;
    },
  },
});

export const {
  setAchPayment,
  setSameDayPayment,
  resetAchPayment,
  handleRoutingDetails,
} = achPaymentSlice.actions;

export default achPaymentSlice.reducer;
